export default __webpack_public_path__ + "static/media/move_light.e5836430.svg";